import { eventsConstants } from '../constants'

const initialState = {
  list: null
}

export default function events(state = initialState, action) {
  switch (action.type) {
    case eventsConstants.EVENTS_UPDATE:
      return {
        ...state,
        list: (state.list === null
          ? [action.payload]
          : state.list.findIndex((x) => x.id === action.payload.id) === -1
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
              return item.id === action.payload.id ? action.payload : item
            })
        ).sort((a, b) => (a.date < b.date ? -1 : 1))
      }
    case eventsConstants.EVENTS_REMOVE:
      return {
        ...state,
        list: state.list
          .filter((item) => {
            return item.id !== action.payload.id
          })
          .sort((a, b) => (a.date < b.date ? -1 : 1))
      }
    default:
      return state
  }
}
